const HOURS_PER_DAY = 24;
const MS_PER_HOUR = 60 * 60 * 1000;
const MS_PER_DAY = HOURS_PER_DAY * MS_PER_HOUR;

export const POST_TTL_DAYS = 30;
export const POST_TTL_MS = POST_TTL_DAYS * MS_PER_DAY;

const toDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  if (value instanceof Date) return value;

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getPostCreatedAt = (post) => toDate(post?.createdAt);

export const getPostExpiresAt = (post) => {
  const explicitExpiresAt = toDate(post?.expiresAt);
  if (explicitExpiresAt) return explicitExpiresAt;

  const createdAt = getPostCreatedAt(post);
  if (!createdAt) return null;

  return new Date(createdAt.getTime() + POST_TTL_MS);
};

export const isPostExpired = (post, nowMs = Date.now()) => {
  const expiresAt = getPostExpiresAt(post);
  return expiresAt ? expiresAt.getTime() <= nowMs : false;
};

export const getEngagementScore = (post = {}) =>
  (post.likes || 0) * 3 +
  (post.commentCount || 0) * 2 +
  (post.views || 0) * 0.5;

export const getTrendingScore = (post = {}, nowMs = Date.now()) => {
  const createdAt = getPostCreatedAt(post);
  const createdMs = createdAt ? createdAt.getTime() : nowMs;
  const ageHours = Math.max(0, (nowMs - createdMs) / MS_PER_HOUR);
  const decay = ageHours / HOURS_PER_DAY;
  const rawScore = getEngagementScore(post) - decay;
  return Math.max(0, Math.round(rawScore));
};

export const getNewPostExpiresAt = (nowMs = Date.now()) =>
  new Date(nowMs + POST_TTL_MS);
